export default "__VITE_ASSET__a2116b43__"